export function LabCloseIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg aria-hidden width="14" height="14" viewBox="0 0 14 14" fill="currenColor" xmlns="http://www.w3.org/2000/svg" className="size-4 lg:size-3.5" {...props}>
      <path d="M3.08984 10.0899L10.0898 3.08987L10.9101 3.91012L3.91009 10.9101L3.08984 10.0899Z" />
      <path d="M3.91016 3.08987L10.9102 10.0899L10.0899 10.9101L3.08991 3.91012L3.91016 3.08987Z" />
    </svg>
  );
}
